<template>
  <div>
    <div class="bg-dark m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-white p-b-30">
            <div class="media">
              <div class="avatar avatar mr-3">
                <div class="avatar-title bg-success rounded-circle mdi mdi-printer"></div>
              </div>
              <div class="media-body">
                <h3 class="p-t-10">{{ pageTitle }}</h3>
                <p class="opacity-75"></p>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-center m-b-30 ml-auto">
            <div class="text-md-right">
              <router-link v-can="'pos.read'" is="el-button" :to="{name: 'poses'}" icon="el-icon-s-order" type="primary">
                {{ $t('pos.button.all') }}
              </router-link>
              <el-button v-can="'pos.create'" @click="showCreateDialog" icon="el-icon-plus"  type="success">
                {{ $t('pos.button.create') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-p-o-s @close="closeCreateDialog" :display="displayCreateDialog" @created="posCreated"></create-p-o-s>
    <transition name="slide-fade">
      <router-view @parent-title="updateTitle"/>
    </transition>
  </div>
</template>

<script>
import CreatePOS from './Modal/CreateEditPOS.vue'
export default {
  name: 'POS',
  components: { CreatePOS },
  data () {
    return {
      pageTitle: '',
      displayCreateDialog: false
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    },
    showCreateDialog () {
      this.displayCreateDialog = true
    },
    closeCreateDialog () {
      this.displayCreateDialog = false
    },
    posCreated (data) {
      this.$emit('new-pos', data)
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('pos.title.pos'))
  }
}
</script>

<style scoped>

</style>
